export default class ValidatorModule {
    static simple(data, except) {
        let val = []
        Object.keys(data).forEach(key => {
            if (except) {
                if (!except.includes(key)) val.push(Boolean(data[key]))
            } else {
                val.push(Boolean(data[key]))
            }
        });
        return val.every((elem) => elem >= true)
    }
}
